<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { fade } from 'svelte/transition';
	import Blok from '../blok.svelte';
	import type { SbVideo } from '../types';
	import type { ImageBlock } from '../blocks/imageBlock.svelte';

	interface Props {
		assets: Array<ISbStoryData<ImageBlock | SbVideo>['content']>;
		active?: number;
		onselect?: (index: number) => void;
	}

	let { assets, active = 0, onselect }: Props = $props();
</script>

<div class="scrollbar-hide flex gap-x-2 overflow-x-scroll px-2 lg:gap-x-4">
	{#each assets as asset, index}
		<button
			onclick={() => onselect?.(index)}
			class="relative h-15 w-20 shrink-0 overflow-hidden rounded-[4px] bg-gray-3/50 transition-opacity lg:rounded-[8px]"
		>
			{#if asset.component === 'mux_video'}
				<Blok content={asset} hideControls />
			{:else}
				<Blok content={asset} />
			{/if}
			{#if active === index}
				<span transition:fade={{ duration: 100 }} class="absolute inset-0 bg-black/[0.28]"></span>
			{/if}
		</button>
	{/each}
</div>
